import React from "react";
import styled from "styled-components";

const Icon = styled.i`
  &.disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

const CheckBox = ({ checked, onChange, disabled = false }) => {
  return (
    <Icon
      className={`material-icons font-16 hyperlink${
        disabled ? " disabled" : ""
      }`}
      onClick={() => {
        if (disabled) return;
        onChange(!checked);
      }}
    >
      {checked ? "check_box" : "check_box_outline_blank"}
    </Icon>
  );
};

export default CheckBox;
